import React from 'react';

export const useSingleExecutionFunction = <T extends (...args: never[]) => void>(fn: T) => {
  const hasRunRef = React.useRef(false);

  return (...args: Parameters<T>) => {
    if (!hasRunRef.current) {
      fn(...args);
      hasRunRef.current = true;
    }
  };
};
